var map = {
	"./van-blue.png": "3759",
	"./van-dark-grey.png": "ebe9",
	"./van-green.png": "1619",
	"./van-grey.png": "7854",
	"./van-orange.png": "52d9",
	"./van-red.png": "0b39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "92cf";